import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileUtilsService {

  getCleanName(name: string, createdDate?: string): string {
    if (!name) return '';

    let cleanName = name.includes('_cus_') ? name.split('_cus_')[0] : name;
    const dateSuffix = this.getDateSuffix(createdDate);
    
    return `${cleanName}_${dateSuffix}`;
  }

  private getDateSuffix(dateString?: string): string {
    const dateToUse = dateString ? new Date(dateString) : new Date();
    
    const year = dateToUse.getFullYear();
    const month = String(dateToUse.getMonth() + 1).padStart(2, '0');
    const day = String(dateToUse.getDate()).padStart(2, '0');
    
    return `${year}${month}${day}`;
  }

  getFileExtension(url: string): string {
    return url.split('.').pop() || '';
  }
}
